import { html, LitElement, unsafeCSS } from "lit";
import { customElement, query } from "lit/decorators.js";

import styles from './Ripple.scss?inline';

@customElement('app-ripple')
export class Ripple extends LitElement {
    static styles = [unsafeCSS(styles)];
    @query('.ripple-container') container!: HTMLElement;

    render() {
        return html`<div class="ripple-container"></div>`;
    }

    firstUpdated() {
        const parent = this.parentElement || (this.getRootNode() as ShadowRoot).host as HTMLElement;
        if (!parent) return;
        parent.addEventListener('pointerdown', this._handlePointerDown);
    }

    private _handlePointerDown = (ev: PointerEvent) => {
        this.createRipple(ev);
    };

    createRipple(ev: PointerEvent) {
        if (!this.container) return;
        const rect = this.getBoundingClientRect();

        const x = ev.clientX - rect.left;
        const y = ev.clientY - rect.top;

        const size = Math.max(rect.width, rect.height);

        const rippleElement = document.createElement('span');
        rippleElement.classList.add('ripple');
        rippleElement.style.width = `${size}px`;
        rippleElement.style.height = `${size}px`;
        rippleElement.style.left = `${x}px`;
        rippleElement.style.top = `${y}px`;

        this.container.appendChild(rippleElement);

        rippleElement.addEventListener('animationend', () => {
            rippleElement.remove();
        });
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();

        const parent = this.parentElement;
        if (!parent) return;
        parent.removeEventListener('pointerdown', this._handlePointerDown);
    }
}